// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2705": "375c6902","5822": "67402b0a","5944": "76e0070a","7462": "ea3fbb21","8150": "3f898976",}[chunkId] + ".css"
}